import { brandColors } from './brand';

export const brandToneColors = {
  brandOne120: '#006A4D',
  brandOne100: brandColors.brandOne,
  brandOne80: '#0BE248',
  brandOne50: '#6CF479',
  brandOne20: '#C7FFC6', // Made this the same as brandOne10
  brandOne10: '#C7FFC6',
  brandTwo120: '#000000',
  brandTwo100: brandColors.brandTwo,
  brandTwo80: '#323233',
  brandTwo50: '#C9C9C9',
  brandTwo20: '#F1F1F1',
  brandTwo10: '#FFFFFF',
} as const;
